// Collect-all validation for the create/edit forms.
//
// The multi-record modules used to check required fields one at a time —
// `if (!a) { notify('A is required'); return; }` then the same for B — so a user
// filling a form saw the next missing field only after fixing the first, one
// save at a time (CHM-054). These helpers gather every empty required field so
// the form can name them all in a single message.

/** The labels of the required fields that are empty, in the order given. */
export const missingRequired = (
  fields: Array<[value: unknown, label: string]>
): string[] =>
  fields
    .filter(([value]) => String(value ?? '').trim() === '')
    .map(([, label]) => label);

/**
 * One message for however many fields are missing:
 *   []                 -> ''      (nothing to report)
 *   ['Name']           -> 'Name is required.'
 *   ['Name', 'Date']   -> 'Please fill in: Name, Date.'
 */
export const requiredError = (missing: string[]): string => {
  if (missing.length === 0) return '';
  if (missing.length === 1) return `${missing[0]} is required.`;
  return `Please fill in: ${missing.join(', ')}.`;
};
